import { Anchor, Group, Kbd, Text, UnstyledButton } from '@mantine/core';
import { IconChevronLeft, IconSearch } from '@tabler/icons-react';
import { Link } from 'react-router';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { SecretMenuTool } from './secretMenuCatalogue';
import SecretMenuToolMarkers from './SecretMenuToolMarkers';

type SecretMenuToolHeaderProps = {
  tool: SecretMenuTool;
  onSearch: () => void;
};

export default function SecretMenuToolHeader({ tool, onSearch }: SecretMenuToolHeaderProps) {
  return (
    <Group justify="space-between" wrap="nowrap" px="lg" pt="sm">
      <Group gap="xxs" wrap="wrap">
        <Anchor component={Link} to="/secret-menu" underline="never" c="gray.7">
          <Group gap={2} wrap="nowrap">
            <IconChevronLeft size={16} />
            <Text size="textSm" fw={FONT_WEIGHTS.medium} inherit>
              Secret menu
            </Text>
          </Group>
        </Anchor>
        <Text size="textSm" c="gray.4">
          /
        </Text>
        <Text size="textSm" fw={FONT_WEIGHTS.medium}>
          {tool.label}
        </Text>
        <SecretMenuToolMarkers tool={tool} />
      </Group>
      <UnstyledButton onClick={onSearch}>
        <Group gap="xxs" wrap="nowrap">
          <IconSearch size={14} color="var(--mantine-color-gray-6)" />
          <Text size="textXs" c="dimmed">
            <Kbd>Cmd</Kbd> + <Kbd>K</Kbd>
          </Text>
        </Group>
      </UnstyledButton>
    </Group>
  );
}
